__turbopack_context__.v({
  "regular": "BottomControllerPrereservation-module-scss-module__ecakFq__regular",
  "wideOnMobile": "BottomControllerPrereservation-module-scss-module__ecakFq__wideOnMobile",
});
